import { useState } from "react";
import GlassCard from "@/v2/components/GlassCard";
import { ChevronDown, ChevronUp, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import type { V2RealityCheck } from "@/v2/hooks/useV2Sprint";

export default function RealityCheckSummary({ rc }: { rc: V2RealityCheck | null }) {
  const [open, setOpen] = useState(false);

  if (!rc) {
    return (
      <GlassCard className="!p-5">
        <p className="text-xs uppercase tracking-widest text-secondary">Reality Check</p>
        <p className="text-sm text-slate-200 mt-1 font-semibold">
          Non hai collegato un Reality Check
        </p>
        <p className="text-xs text-slate-400 mt-2">
          Lo Sprint funziona lo stesso con suggerimenti generici. Per consigli su misura, fai
          prima il Reality Check: è gratuito e richiede 5 minuti.
        </p>
        <Link
          to="/v2/reality-check"
          className="mt-3 inline-flex items-center gap-1 text-sm text-secondary hover:text-secondary/80 font-medium"
        >
          Fai il Reality Check gratuito <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </GlassCard>
    );
  }

  const Row = ({ label, value }: { label: string; value?: string | null }) =>
    value ? (
      <div>
        <p className="text-[11px] uppercase tracking-wider text-secondary mb-0.5">{label}</p>
        <p className="text-sm text-slate-200">{value}</p>
      </div>
    ) : null;

  return (
    <GlassCard className="!p-5">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between text-left"
      >
        <div>
          <p className="text-xs uppercase tracking-widest text-secondary">Reality Check</p>
          <p className="text-sm font-semibold mt-0.5">
            {rc.verdict ?? "Riepilogo idea"}
          </p>
          {rc.idea_summary && (
            <p className="text-xs text-slate-400 mt-1 line-clamp-1">{rc.idea_summary}</p>
          )}
        </div>
        {open ? (
          <ChevronUp className="h-4 w-4 text-slate-400" />
        ) : (
          <ChevronDown className="h-4 w-4 text-slate-400" />
        )}
      </button>

      {open && (
        <div className="mt-4 grid gap-3 sm:grid-cols-2 border-t border-white/5 pt-4">
          <Row label="Idea" value={rc.idea_summary} />
          <Row label="Target" value={rc.target_summary} />
          <Row label="Rischio principale" value={rc.main_risk} />
          <Row
            label="Benchmark"
            value={
              rc.benchmark_label
                ? `${rc.benchmark_label}${rc.percentile != null ? ` · ${rc.percentile}°` : ""}`
                : null
            }
          />
          <Row label="Esperimento 48h" value={rc.experiment_48h} />
          <Row label="Metrica di successo" value={rc.success_metric} />
          <Row label="Soglia minima" value={rc.minimum_success_threshold} />
          <Row label="Angolo CTA" value={rc.cta_angle} />
        </div>
      )}
    </GlassCard>
  );
}
